export enum ApplicationType {
	Card = 'Card',
	Deposit = 'Deposit',
	Loan = 'Loan',
}
